/* global axios */
import ApiClient from '../ApiClient';

class VoiceAgentActions extends ApiClient {
  constructor() {
    super('voice_agents/actions', { accountScoped: true });
  }

  get({ page = 1, voiceAgentId } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        voice_agent_id: voiceAgentId,
      },
    });
  }

  test(actionData) {
    return axios.post(`${this.url}/test`, actionData);
  }
}

export default new VoiceAgentActions();
